
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { CollectionType, CollectionPayloadType } from "@/common/types/collection";

export async function collectionList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/list${queryString}`
    );
}

export async function collectionGet(
    collection_id: string
) {
    return await clientAxios.get(
        `collection/${collection_id}/show`
    );
}

export async function collectionAdd(
    payload: CollectionPayloadType
) {
    return await clientAxios.post(
        `collection/create`,
        payload
    );
}

export async function collectionCopy(
    collection_id: string
) {
    return await clientAxios.post(
        `collection/${collection_id}/copy`,
        null
    );
}

export async function collectionPatch(
    collection_id: string,
    payload: Partial<CollectionType>
) {
    return await clientAxios.patch(
        `collection/${collection_id}/patch`,
        { payload }
    );
}

export async function collectionDel(
    collection_id: string,
) {
    return await clientAxios.del(
        `collection/${collection_id}/delete`,
    );
}
